import {
  FILTER_ENTITY_TYPE_API,
  FILTER_ENTITY_TYPE_API_KEY,
  FILTER_ENTITY_TYPE_APP,
  FILTER_ENTITY_TYPE_ORG,
  FILTER_ENTITY_TYPE_GATEWAY,
  FILTER_ENTITY_TYPE_RESPONSE,
  FILTER_ENTITY_TYPE_URI,
} from './filter';

export const RespCodeList = {
  '200-299': {
    labelKey: 'label.analytics.resp.code.success.string',
    rangeKey: 'label.analytics.resp.code.success.range',
    value: [200, 299],
  },
  '300-399': {
    labelKey: 'label.analytics.resp.code.redirects.string',
    rangeKey: 'label.analytics.resp.code.redirects.range',
    value: [300, 399],
  },
  '400-499': {
    labelKey: 'label.analytics.resp.code.client.error.string',
    rangeKey: 'label.analytics.resp.code.client.error.range',
    value: [400, 499],
  },
  '500-599': {
    labelKey: 'label.analytics.resp.code.server.error.string',
    rangeKey: 'label.analytics.resp.code.server.error.range',
    value: [500, 599],
  },
};

export const MetricFilterDropdownValues = {
  name: 'Metric selection',
  value: [
    {
      uuid: '1',
      text: 'API Hits',
      value: 'hits',
    },
    {
      uuid: '2',
      text: 'Average Response Time',
      value: 'latency',
    },
  ],
};

export const FilterList = [
  {
    id: 1,
    value: FILTER_ENTITY_TYPE_API,
    filterDimension: 'apiId',
    text: 'label.analyticsDashboard.filter.dropdown.add.api',
  },
  {
    id: 2,
    value: FILTER_ENTITY_TYPE_APP,
    filterDimension: 'appId',
    text: 'label.analyticsDashboard.filter.dropdown.add.application',
  },
  {
    id: 3,
    value: FILTER_ENTITY_TYPE_GATEWAY,
    filterDimension: 'gatewayServerId',
    text: 'label.analyticsDashboard.filter.dropdown.add.gatewayServers',
  },
  {
    id: 4,
    value: FILTER_ENTITY_TYPE_ORG,
    filterDimension: 'orgId',
    text: 'label.analyticsDashboard.filter.dropdown.add.organization',
  },
  {
    id: 5,
    value: FILTER_ENTITY_TYPE_RESPONSE,
    filterDimension: 'respCode',
    text: 'label.analyticsDashboard.filter.dropdown.add.response',
  },
  {
    id: 6,
    value: FILTER_ENTITY_TYPE_URI,
    filterDimension: 'uri',
    text: 'label.analyticsDashboard.filter.dropdown.add.uri',
  },
  {
    id: 7,
    value: FILTER_ENTITY_TYPE_API_KEY,
    filterDimension: 'apiKeyId',
    text: 'label.analyticsDashboard.filter.dropdown.add.apiKey',
  },
];
